module.exports = __webpack_public_path__ + "static/media/a_domani.3b4a8e57.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/sounds/a_domani.mp3
// module id = 184
// module chunks = 0